import {
  EntityId,
  EntitySelectEntity,
  EntitySelectSubEntity,
} from '@factorialco/f0-react/dist/experimental'
import { AvatarNameForSelectFragment } from 'generated/resources/graphql'
import orderBy from 'lodash/orderBy'

import buildUrl from 'modules/core/lib/buildUrl'

export function groupByWorkplaces(
  employees?: AvatarNameForSelectFragment[],
  excludedIds: EntityId[] = [],
  expandedElements: EntityId[] = []
): EntitySelectEntity[] {
  if (!employees) return []
  const workplaceMap = new Map<number, EntitySelectEntity>()

  employees.forEach((employee) => {
    const { id, fullName, avatar, firstName, lastName, preferredName, defaultLocation } = employee

    if (!defaultLocation) return

    let workplaceEntity = workplaceMap.get(defaultLocation.id)

    if (!workplaceEntity) {
      workplaceEntity = {
        id: defaultLocation.id,
        name: defaultLocation.name,
        expanded: expandedElements.includes(defaultLocation.id),
        subItems: [],
      }
      workplaceMap.set(defaultLocation.id, workplaceEntity)
    }

    const subItem: EntitySelectSubEntity = {
      subId: id,
      subName: fullName,
      subAvatar: avatar ? buildUrl(avatar.url) : undefined,
      subSearchKeys: [
        preferredName ? `${preferredName} ${lastName}` : null,
        `${firstName} ${lastName}`,
      ].filter(Boolean),
    }

    if (!excludedIds.includes(id)) {
      workplaceEntity.subItems?.push(subItem)
    }
  })

  return orderBy(Array.from(workplaceMap.values()), 'name', 'asc')
}
